
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/glacier-classic-portable-refrigerator",
      function () {
        return require("private-next-pages/glacier-classic-portable-refrigerator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/glacier-classic-portable-refrigerator"])
      });
    }
  